import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { store } from '../src/redux/store';
import { Provider } from 'react-redux';
import { ErrorBoundary } from "react-error-boundary";
// Sub-barrels, not the top-level Design_System barrel — avoids the redux import cycle.
import { AppBox } from './components/Design_System/Layout/Box';
import { AppPaper } from './components/Design_System/Layout/Paper';
import { AppTitle, AppLabel } from './components/Design_System/Components/Label';
import { AppButton } from './components/Design_System/Components/Button';
import { AppContainer } from './components/Design_System/Layout/Container';
import { AppAlert } from './components/Design_System/Layout/Feedback';

// apexcharts 4 changed these defaults; keep the chart look we had on apexcharts 3
// (12px legend markers without outline, 2px legend row gap, softer label shadow).
window.Apex = {
  legend: {
    markers: { size: 6, strokeWidth: 0 },
    itemMargin: { vertical: 2 },
  },
  dataLabels: {
    dropShadow: { opacity: 0.45 },
  },
};

// Last-resort fallback for anything ChunkErrorBoundary (App.js/RouteWithLayout) didn't handle.
function fallbackRender({ error }) {
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    /Loading( CSS)? chunk [\w.-]+ failed/i.test(error?.message || '') ||
    (error?.message || '').includes('Failed to fetch dynamically imported module');

  return (
    <AppBox sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <AppContainer maxWidth="xs">
        <AppPaper sx={{ textAlign: 'center', p: 4 }}>
          <AppTitle showAccent={false} sx={{ justifyContent: 'center', mb: 1 }}>
            {isChunkError ? 'Update available' : 'Something went wrong'}
          </AppTitle>
          <AppLabel sx={{ display: 'block', mb: 3 }}>
            {isChunkError
              ? 'A new version of the app is available. Please reload to continue.'
              : 'An unexpected error occurred. Reloading the page may resolve the issue.'}
          </AppLabel>
          <AppButton variant="contained" color="primary" onClick={() => window.location.reload()}>
            Reload Page
          </AppButton>
          {process.env.NODE_ENV === 'development' && (
            <AppAlert severity="error" sx={{ mt: 3, textAlign: 'left', whiteSpace: 'pre-wrap' }}>
              {error.message}
            </AppAlert>
          )}
        </AppPaper>
      </AppContainer>
    </AppBox>
  );
}
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ErrorBoundary
      fallbackRender={fallbackRender}
      onReset={(details) => {
      }}
    >
      <App />
    </ErrorBoundary>
  </Provider>,
);
